module.exports = __webpack_public_path__ + "static/img/qiwi_logo_Q.081e5f3d.svg";